// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"60011df2","389":"aaaa84f4","453":"61829909","455":"e9300f29","857":"06f7e20e","977":"bb777cdc"}[chunkId] + ".chunk.js";
};